'use client';
import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useEventLiveScores } from './useEventLiveScores';
/** Results/participant corrections refresh the server projection without losing the division URL. */
export function useJourneyRefresh(eventId: string, enabled: boolean) {
  const router = useRouter();
  const live = useEventLiveScores(eventId, enabled);
  const revision = useRef(live.topologyRevision);
  useEffect(() => {
    if (live.topologyRevision !== revision.current) {
      revision.current = live.topologyRevision;
      router.refresh();
    }
  }, [live.topologyRevision, router]);
}
